export var Network; // an alias, keeping Network for now in case of breaking changes

(function (Network) {
  Network["MAIN"] = "f";
  Network["TEST"] = "t";
})(Network || (Network = {}));

export var CoinType;

(function (CoinType) {
  CoinType["MAIN"] = "f";
  CoinType["TEST"] = "t";
})(CoinType || (CoinType = {}));
//# sourceMappingURL=coinType.js.map